import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';

interface DialogData {

}

@Component({
  selector: 'app-mfg-terms-conditions',
  templateUrl: './mfg-terms-conditions.component.html',
  styleUrls: ['./mfg-terms-conditions.component.scss']
})
export class MfgTermsConditionsComponent implements OnInit {

  termsForm: FormGroup

  constructor(
    private dialogref: MatDialogRef<MfgTermsConditionsComponent>,
    private toastr: ToastrService,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void {

    let termsConditions = this.data["data"]

    this.termsForm = new FormGroup({
      'terms_and_conditions': new FormControl("", [Validators.required, Validators.minLength(5)])
    });


    this.editTermsConditions(termsConditions)

  }


  close() {
    this.dialogref.close();
  }

  editTermsConditions(data) {
    this.termsForm.controls['terms_and_conditions'].setValue(data)
  }

  submit() {
    let formData = this.termsForm.get('terms_and_conditions').value
    let form = {
      "vendor": {
        "terms_and_conditions": formData
      }
    }

    this.adminService.updateTermsConditions(form).subscribe(
      res => {
        this.toastr.success('Updated Terms & Conditions', 'Success');
        this.close();
      },
      err => {
        this.toastr.error('Something Went Wrong', 'Error');
      }
    )

  }


}

